import { KONG_GENERAL_HOST, KONG_PROJECTS } from '@helpers/api/kong';
import type { IGuideShopCore } from 'types/guides/guideshop';

const VALID_STATUS = [200];

const getAllGuides = async (): Promise<IGuideShopCore[]> | null => {
  const { GUIDE_SHOP } = KONG_PROJECTS;
  const url = `${KONG_GENERAL_HOST}/${GUIDE_SHOP.prefix}/store`;
  const options = {
    method: 'GET',
    headers: {
      ...GUIDE_SHOP.headers,
      mmtoken: process.env.GUIDE_SHOP_MANAGER_TOKEN,
    },
  };
  try {
    const response = await fetch(url, options);

    if (!VALID_STATUS.includes(response.status)) {
      throw new Error(`Invalid response status ${response.status}`);
    }

    return response.json().then(res => res.data as IGuideShopCore[]);
  } catch (err) {
    return [];
  }
};

export default getAllGuides;
